import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Box } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import dayjs from 'dayjs';

import useCurrency from '../../../hooks/common/useCurrency';
import ReturnStatusBadge from './ReturnStatusBadge';

const ReturnsTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { format: formatPrice } = useCurrency();

    const customerName = item.user?.name
        || item.customer?.name
        || item.order?.user?.name
        || '-';
    const customerEmail = item.user?.email
        || item.customer?.email
        || item.order?.user?.email;

    const orderNumber = item.order?.order_number || item.order_number;
    const refundAmount = item.refund_amount ?? item.total_refund ?? 0;
    const requestedAt = item.requested_at || item.created_at;

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, item.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align="start">{index + 1}</TableCell>

            {/* Return # */}
            <TableCell>
                <Typography
                    component={RouterLink}
                    to={`/returns/${item.id}`}
                    variant="body2"
                    fontWeight="bold"
                    sx={{ color: 'primary.main', textDecoration: 'none' }}
                >
                    {item.return_number || `#${item.id}`}
                </Typography>
            </TableCell>

            {/* Order # */}
            <TableCell>
                {orderNumber ? (
                    <Typography
                        component={RouterLink}
                        to={`/orders/${item.order?.id || item.order_id}`}
                        variant="body2"
                        sx={{ color: 'text.primary', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                    >
                        {orderNumber}
                    </Typography>
                ) : (
                    '-'
                )}
            </TableCell>

            {/* Customer */}
            <TableCell>
                <Box>
                    <Typography variant="body2" fontWeight="medium">
                        {customerName}
                    </Typography>
                    {customerEmail && (
                        <Typography variant="caption" color="text.secondary">
                            {customerEmail}
                        </Typography>
                    )}
                </Box>
            </TableCell>

            {/* Status */}
            <TableCell align="center">
                <ReturnStatusBadge status={item.status} />
            </TableCell>

            {/* Refund Amount */}
            <TableCell align="center">
                <Typography variant="body2" fontWeight="bold">
                    {formatPrice(refundAmount)}
                </Typography>
            </TableCell>

            {/* Requested */}
            <TableCell align="center">
                <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
                    {requestedAt ? dayjs(requestedAt).format('YYYY-MM-DD HH:mm') : '-'}
                </Typography>
            </TableCell>

            {/* Actions */}
            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ReturnsTableRow;
